import { render, staticRenderFns } from "./ZTagGroup.vue?vue&type=template&id=21c48891&"
import script from "./ZTagGroup.vue?vue&type=script&lang=ts&"
export * from "./ZTagGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports